import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import QuantityStepper from '@Components/Shop/QuantityStepper';

const Cart = (props) => {

    const { cartOpen, setCartOpen, cartItems, handleRemoveFromCart, handleUpdateCartLineQuantity, formatMoney, cart, getMaxQuantity} = props;
    const cartSubtotal = cart?.cost?.subtotalAmount;

    return (
        <Drawer anchor="right" open={cartOpen} onClose={() => setCartOpen(false)} style={{zIndex: '1401'} }>
            <div style={{ width: 380, padding: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3>CART</h3>
                    <IconButton onClick={() => setCartOpen(false)} aria-label="Close cart">
                        <CloseIcon />
                    </IconButton>
                </div>

                <Divider />

                <List>
                    {cartItems.length === 0 ? (
                        <ListItem disableGutters={true}>
                            <ListItemText primary="CART IS EMPTY" style={{fontSize: '14px'}} />
                        </ListItem>
                    ) : cartItems.map(({ node }) => {
                        const merchandise = node.merchandise;
                        const lineMaxQuantity = getMaxQuantity(merchandise?.quantityAvailable);
                        return (
                            <ListItem key={node.id} alignItems="flex-start" disableGutters={true} secondaryAction={
                                <div style={{ display: 'flex', flexDirection: 'column', height: '60px', justifyContent: 'space-between' }}>
                                <IconButton
                                        color="error"
                                        size="small"
                                        onClick={() => handleRemoveFromCart({
                                            variantId: merchandise?.id
                                        })}
                                        aria-label="Remove item from cart"
                                        style={{ textAlign: 'right', display: 'block', padding: '0', margin: '0', backgroundColor: 'transparent' }}
                                >
                                    <DeleteIcon fontSize='small'></DeleteIcon>
                                </IconButton>
                                    <div style={{fontSize: '14px', textAlign: 'right'} }>
                                        {formatMoney(merchandise.price?.amount, merchandise.price?.currencyCode)}
                                    </div>
                                </div>
                            }>
                                <ListItemAvatar style={{marginBlock: '4px'} }>
                                    <Avatar
                                        style={{width: '65px', height: '65px'}}
                                        variant="rounded"
                                        src={merchandise.image?.url || ''}
                                    >
                                        {!merchandise.image?.url && <ShoppingBagIcon fontSize='large'/>}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={
                                        <div style={{display: 'flex', flexDirection: 'column', height: '65px', justifyContent: 'space-between'}}>
                                            <div style={{ fontSize: '14px', textAlign: 'left', marginLeft: '10px', marginTop: '1px', marginBottom: '2px' }}>{merchandise.product?.title || merchandise.title}</div>
                                        <QuantityStepper
                                            quantity={node.quantity}
                                            maxQuantity={lineMaxQuantity}
                                            onDecrease={() => handleUpdateCartLineQuantity(node, node.quantity - 1)}
                                            onIncrease={() => handleUpdateCartLineQuantity(node, node.quantity + 1)}
                                        />
                                </div>
                                    }
                                />
                            </ListItem>
                        );
                    })}
                </List>

                <Divider style={{ margin: '16px 0' }} />
                {cartSubtotal && (
                    <div style={{ margin: '8px 0 16px 0', fontSize: '14px', display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <div>SUBTOTAL</div>
                        <div>{formatMoney(cartSubtotal.amount, cartSubtotal.currencyCode)}</div>
                    </div>
                )}
                <div style={{fontSize: '12px', textAlign: 'center', marginBottom: '10px'} }>
                    Shipping and discount codes are added at checkout.
                </div>
                <Button
                    fullWidth
                    variant="contained"
                    disabled={!cart?.checkoutUrl}
                    onClick={() => window.location.href = cart?.checkoutUrl + "&channel=headless-storefronts"}
                >
                    Checkout
                </Button>
            </div>
        </Drawer>
    )
  
};

export default Cart;

